import * as React from 'react';
import { memo } from 'react';
import { getDepartureDate } from '../../../helpers/cruisePageHelpers';
import { __ } from '../../../helpers/TranslationService';
import { ICruiseIconOption, ISail } from '../../../interfaces';
import CruiseStageInclusivesList from './CruiseStageInclusivesList';

interface IDescriptionList {
    zone: string;
    companyTitle: string;
    shipTitle: string;
    startHarbour: string;
    endHarbour?: string;
    nightsString?: string;
    dateRange?: string;
    icons?: {
        icon: ICruiseIconOption;
        text: string;
    }[];
    cruiseId: number;
    sails: ISail[];
}

const CruiseStageDescriptionList = (props: IDescriptionList) => {
    const {
        zone,
        companyTitle,
        shipTitle,
        startHarbour,
        endHarbour,
        nightsString,
        dateRange,
        icons,
        cruiseId,
        sails
    } = props;

    const descrs: { label: string; value: JSX.Element | string }[] = [
        {
            label: __('Company', 'dreamlines'),
            value: companyTitle,
        },
        {
            label: __('Ship', 'dreamlines'),
            value: shipTitle,
        },
        {
            label: __('Destination', 'dreamlines'),
            value: zone,
        },
        {
            label: __('Startharbour', 'dreamlines'),
            value: startHarbour,
        },
        {
            label: __('Endharbour', 'dreamlines'),
            value: endHarbour,
        },
        {
            label: __('Duration', 'dreamlines'),
            value: nightsString,
        },
        {
            label: __('Dates', 'dreamlines'),
            value: getDepartureDate({dateRange, sails}),
        },
        {
            label: __('CruiseID', 'dreamlines'),
            value: String(cruiseId),
        },
        {
            label: __('included services', 'dreamlines'),
            value: icons.length > 0 && <CruiseStageInclusivesList icons={icons} />,
        },
    ];

    return (
        <ul className="cruise-stage-overview__ul">
            {descrs.map(
                (descr, i) =>
                    descr.value && (
                        <li
                            key={`description-${i}`}
                            className="cruise-stage-overview__li col-xs-12 col-is-6 col-sm-6 col-md-12"
                        >
                            <label className="cruise-stage-overview__label">{descr.label}:</label>
                            <span className="cruise-stage-overview__descr">{descr.value}</span>
                        </li>
                    ),
            )}
        </ul>
    );
};
export default memo(CruiseStageDescriptionList);
